<script setup>
import { useAttrs } from 'vue'

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
})

const attrs = useAttrs()

const sprite = new URL('src/assets/icon-sprite.svg', import.meta.url).href
</script>

<template>
  <svg
    class="tw-inline-block tw-size-[1em] tw-flex-shrink-0 tw-fill-current tw-stroke-current tw-stroke-0"
    v-bind="attrs"
    xmlns="http://www.w3.org/2000/svg"
  >
    <use :href="`${sprite}#${props.name}`" />
  </svg>
</template>
